export { default as SuggestedServiceItem } from './SuggestedServiceItem';
